import { Component } from '@angular/core';

@Component({
    selector: 'app-vrbo',
    templateUrl: './vrbo.component.html',
    styleUrls: ['./vrbo.component.css'],
    standalone: false
})
export class VRBOComponent {
  tabIndex = 0;
}


